import { Typography } from "@mui/joy";
import { AutoAwesomeOutlined } from "@mui/icons-material";

export function MarvinSenderRow() {
    return (
        <Typography color="primary" level="title-sm" startDecorator={<AutoAwesomeOutlined />}>
            Marvin
        </Typography>
    );
}
